"use client";
import { Control, UseFormClearErrors } from "react-hook-form";
// import InputField from "../../../components/common/InputField";
import Input from "../../../components/Input";
import SelectInput from "../../../components/Select";
import {
  useFetchAllShippingPartnersData,
  useFetchAllTireData,
} from "../../../apis/zoneAndTierApis";
import { useEffect } from "react";

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  zoneItem?: any;
};
const PAYMENT_TYPE = [
  { id: 0, text: "CC", value: "CC" },
  { id: 1, text: "COD", value: "COD" },
  { id: 2, text: "BOTH", value: "BOTH" },
];
const AddZoneModal = ({
  register,
  setValue,
  watch,
  errors,
  clearErrors,
  control,
  zoneItem = {},
}: Props) => {
  const { data: tireData, refetch: tireRefetch } = useFetchAllTireData();
  const { data: shippingPartnersData, refetch: shippingPartnersRefetch } = useFetchAllShippingPartnersData();

  useEffect(() => {
    if (zoneItem) {
      setValue("name", zoneItem?.name);
      setValue("tireId", zoneItem?.tireId);
      setValue("courierCompanyId", zoneItem?.courierCompanyId);
      setValue("paymentMode", zoneItem?.paymentMode);
      setValue("capacityPerDay", zoneItem?.capacityPerDay);
      setValue("pricePerShipment", zoneItem?.pricePerShipment);
    }
  }, [zoneItem]);
  
  return (
    <div className="w-[655px] p-4 space-y-4">
      <div className="grid grid-cols-6 gap-4">
        <Input
          className="col-span-3"
          name="name"
          type="text"
          title="Zone Name"
          placeholder="Enter Zone Name"
          register={register}
          error={errors.name}
          validation={{ required: "Zone Name is required" }}
        />
        <SelectInput
          className="col-span-3"
          label={"Select Tire"}
          selectOptions={
            tireData && tireData?.map((tire: any) => ({
              id: tire?.id,
              value: tire?.id,
              text: tire?.name,
            })) || []
          }
          name="tireId"
          clearErrors={clearErrors}
          validation={{ required: "Tire Name is required" }}
          register={register}
          value={watch("tireId")}
          setValue={(val: string) => {
            setValue("tireId", val);
          }}
          error={errors.tireId}
        />
        <SelectInput
          className="col-span-6"
          label={"Select Courier Company"}
          selectOptions={
            shippingPartnersData?.map((shippingPartners: any) => ({
              id: shippingPartners?.id,
              value: shippingPartners?.id,
              text: shippingPartners?.name,
            })) || []
          }
          name="courierCompanyId"
          clearErrors={clearErrors}
          validation={{ required: "Courier Company Name is required" }}
          register={register}
          value={watch("courierCompanyId")}
          setValue={(val: string) => {
            setValue("courierCompanyId", val);
          }}
          error={errors.courierCompanyId}
        />
        <SelectInput
          className="col-span-2"
          label={"Select Payment Mode"}
          selectOptions={PAYMENT_TYPE}
          name="paymentMode"
          clearErrors={clearErrors}
          validation={{ required: "Payment Mode  is required" }}
          register={register}
          value={watch("paymentMode")}
          setValue={(val: string) => {
            setValue("paymentMode", val);
          }}
          error={errors.paymentMode}
        />
        <Input
          className="col-span-2"
          name="capacityPerDay"
          type="text"
          title="Capacity"
          placeholder="Enter Capacity"
          register={register}
          error={errors.capacityPerDay}
          validation={{ required: "Capacity is required" }}
        />
        <Input
          className="col-span-2"
          name="pricePerShipment"
          type="text"
          title="Price Per Shipment"
          placeholder="Enter Price Per Shipment"
          register={register}
          error={errors.pricePerShipment}
          validation={{ required: "Price Per Shipment is required" }}
        />
      </div>
    </div>
  );
};

export default AddZoneModal;
